import { getOrigin, getOriginERL } from '../config/siteConfig';
import { desurveyHoleToScene } from './holeDesurvey';
import { sceneToMine } from './sectionMath';

/** Mine-grid path for a collar. Empty surveys = straight collar azi/dip. */
export function holePathMine(collar, surveys = [], { desurvey = false } = {}) {
  if (!collar) return [];
  const points = desurveyHoleToScene(collar, desurvey ? surveys || [] : [], getOriginERL());
  if (!points?.length) return [];
  const origin = getOrigin();
  return points.map((p) => {
    const mine = sceneToMine(p.x, p.y, p.z, origin);
    return {
      east: mine.east,
      north: mine.north,
      rl: mine.rl,
      depth: Number.isFinite(p.depth) ? p.depth : 0,
    };
  });
}

export function collarMine(collar) {
  const east = parseFloat(collar?.NAT_East);
  const north = parseFloat(collar?.NAT_North);
  const rl = parseFloat(collar?.NAT_RL);
  if (!Number.isFinite(east) || !Number.isFinite(north) || !Number.isFinite(rl)) return null;
  return { east, north, rl, depth: 0 };
}
